import { memo } from 'react';
import { Container, TextContainer, Text, URLDivider, Image, LinkText, LineContainer } from './styles/GobMessageStyles';
import EscudoRD from '../../assets/images/EscudoRD.png'

function GobMessage() {


    return (
        <Container >
            <LineContainer>
                <TextContainer>
                    <Text >
                    {'Este sitio pertenece a la Universidad Abierta para Adultos | Visitar el sitio oficial \r\n'}
                    <LinkText href='https://www.uapa.edu.do/'>www.uapa.edu.do</LinkText>
                    </Text>
                </TextContainer>
            </LineContainer>
        </Container>
    );
}

export default memo(GobMessage);
